export const setChatSettings = (data) => {
   return {
      type: "SET_CHAT_SETTINGS",
      payload: data
   };
};

export function setIsChatOpen(isChatOpen) {
   return { type: "SET_IS_CHAT_OPEN", isChatOpen };
}
export function setIsChatMinimized() {
   return { type: "SET_IS_CHAT_MINIMIZED" };
}

export function setIsChatDocked() {
   return { type: "SET_IS_CHAT_DOCKED" };
}

export function setIsChatFullScreen(fullScreenMode) {
   return { type: "SET_IS_CHAT_FULLSCREEN", fullScreenMode };
}

export function setCurrentRoomsList(
   currentRoomsListFolder: "Messages" | "Contacts" | "Bots" = "Messages"
) {
   return { type: "SET_CURRENT_CHAT_ROOMS_FOLDER", currentRoomsListFolder };
}
